import {
  ORGANIZATION_LIST_ORGANIZATION_INVITES,
  ORGANIZATION_USERS_PATH,
  PROFILE_SUBSCRIPTION_PATH,
  VPX_INVITATION_LIST_PATH,
} from './pagePath';

/** API `type` values returned by GET /api/notification */
export const NOTIFICATION_TYPE = {
  SUBSCRIPTION: 'subscription',
  INVITATION_ACCEPTED: 'invitationAccepted',
  ORGANIZATION_INVITATION: 'organizationInvitation',
  ORGANIZATION_INVITATION_DECLINED: 'organizationInvitationDeclined',
  ORGANIZATION_INVITATION_RESENT: 'organizationInvitationResent',
  VP_INVITATION: 'vpInvitation',
  VP_SHARE_UNREGISTERED_EMAIL: 'vpShareUnregisteredEmail',
  VP_SHARE_RESENT: 'vpShareResent',
  VP_SHARE_ALREADY_SHARED: 'vpShareAlreadyShared',
  VP_INVITATION_ACCEPTED: 'vpInvitationAccepted',
  VP_INVITATION_DECLINED: 'vpInvitationDeclined',
  /** @deprecated Use ORGANIZATION_INVITATION or VP_INVITATION */
  NEW_INVITATION: 'newInvitation',
  DEFAULT: 'default',
};

/**
 * Where each notification type navigates when clicked in the header dropdown.
 * Keys must match API `item.type` strings.
 */
export const NOTIFICATION_NAVIGATION_BY_TYPE = {
  [NOTIFICATION_TYPE.SUBSCRIPTION]: PROFILE_SUBSCRIPTION_PATH,
  [NOTIFICATION_TYPE.INVITATION_ACCEPTED]: ORGANIZATION_USERS_PATH,
  [NOTIFICATION_TYPE.ORGANIZATION_INVITATION]: ORGANIZATION_LIST_ORGANIZATION_INVITES,
  [NOTIFICATION_TYPE.ORGANIZATION_INVITATION_DECLINED]: ORGANIZATION_USERS_PATH,
  [NOTIFICATION_TYPE.ORGANIZATION_INVITATION_RESENT]: ORGANIZATION_USERS_PATH,
  [NOTIFICATION_TYPE.VP_INVITATION]: VPX_INVITATION_LIST_PATH,
  [NOTIFICATION_TYPE.VP_SHARE_UNREGISTERED_EMAIL]: VPX_INVITATION_LIST_PATH,
  [NOTIFICATION_TYPE.VP_SHARE_RESENT]: VPX_INVITATION_LIST_PATH,
  [NOTIFICATION_TYPE.VP_SHARE_ALREADY_SHARED]: VPX_INVITATION_LIST_PATH,
  [NOTIFICATION_TYPE.VP_INVITATION_ACCEPTED]: VPX_INVITATION_LIST_PATH,
  [NOTIFICATION_TYPE.VP_INVITATION_DECLINED]: VPX_INVITATION_LIST_PATH,
  [NOTIFICATION_TYPE.NEW_INVITATION]: ORGANIZATION_LIST_ORGANIZATION_INVITES,
};

export const getNotificationNavigationPath = (type) =>
  NOTIFICATION_NAVIGATION_BY_TYPE[type] ?? null;
